'use client';

import { useSearchParams } from 'next/navigation';
import type { CategoriesEntity } from '@eliadmin/core/src/api/general/types/general-layout-types';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { FiX } from 'react-icons/fi';

type BlogCategoriesProps = {
  categories: CategoriesEntity[];
};

export const BlogCategories = ({ categories }: BlogCategoriesProps) => {
  const { t } = useTranslations();
  const searchParams = useSearchParams();
  const selectedCategory = searchParams.get('category');

  const handleFilterCategory = (id: number | null) => {
    const params = new URLSearchParams(searchParams.toString());
    if (id === null) {
      params.delete('category');
    } else {
      params.set('category', id.toString());
    }

    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.replaceState(null, '', newUrl);
  };

  return (
    <>
      {categories?.map(category => (
        <div key={category?.slug} className="flex gap-1.5 text-base">
          <div
            onClick={() => handleFilterCategory(category.id)}
            className={cn(
              'font-bold text-secondary hover:cursor-pointer',
              category.id.toString() === selectedCategory && 'text-secondary-foreground underline',
            )}
          >
            {category.name}
          </div>
          <span className="text-light text-base text-foreground">({category?.blogs_count})</span>
        </div>
      ))}
      {selectedCategory && (
        <div
          onClick={() => handleFilterCategory(null)}
          className={cn(
            'flex items-center gap-1 font-bold text-destructive-foreground hover:cursor-pointer',
          )}
        >
          <FiX className="h-5 w-5" />
          {t('text2319')}
        </div>
      )}
    </>
  );
};
